import { EXTRA_KITS } from './kits-extra';
import { KITS, type ClassKit } from './weapons';

/** Tous les kits jouables : familles C01/C10 (weapons.ts) et C02–C09, C11–C15 (kits-extra.ts). */
export const ALL_KITS: Record<string, ClassKit> = { ...KITS, ...EXTRA_KITS };
